
export function docAsDataObject(acc,doc) {
    acc[doc.id] = doc.data()
    return acc 
}

export function docsAsDataObject(value) {
    return value.docs.reduce(docAsDataObject,{})
}

export function docAsDataArray(doc) {
    return { id: doc.id, data: doc.data()}
}


// WEBPACK FOOTER //
// ./src/assessments/utils/common.js